import React, { useEffect, useState }  from 'react'
import usePageTitle from 'hooks/usePageTitle';
import { useNavigate } from 'react-router';
import { motion, AnimatePresence } from 'framer-motion';

import {
    SettingsSubscriptionIcon,
    SettingsPaymentMethodIcon,
    SettingsEditSettingsIcon,
    SettingsEmailTemplateIcon,
    SettingsDownloadIcon,
    SettingsUsersIcon,
    SettingsRolesIcon,
    SettingsWebsiteIcon,
    SettingsModelIcon,
    SettingsColorIcon,
    SettingsCategoryIcon,
    SettingsGradeIcon,
    SettingsRepairIcon,
    SettingsShippingIcon,
    SettingsSpecificationIcon,
    SettingsBankIcon,
    SettingsInterestIcon,
    MixGlobalIcon,
    CoolmixIcon,
    GsmfeedIcon,
} from 'ui-component/custom-icons/icons';
import useIsMobile from 'utils/isMobileUtils';
import { FiChevronRight } from 'react-icons/fi';
import config from 'config';
// import config from '../../../config';
const mobileSections = [
    {
        key: 'general',
        title: 'General Settings',
        items: [
            { icon: SettingsEditSettingsIcon, label: 'General Settings', onClick: (history) => history('/settings/general-settings') },
            { icon: SettingsEmailTemplateIcon, label: 'Email Templates', onClick: null },
            { icon: SettingsDownloadIcon, label: 'Download Templates', onClick: null },
        ],
    },
    {
        key: 'access',
        title: 'Access',
        items: [
            { icon: SettingsUsersIcon, label: 'Users', onClick: (history) => history('/settings/user') },
            { icon: SettingsRolesIcon, label: 'Roles', onClick: (history) => history('/settings/role') },
            { icon: SettingsWebsiteIcon, label: 'Client Portal', onClick: null },
        ],
    },
    {
        key: 'categories',
        title: 'Categories',
        items: [
            { icon: SettingsModelIcon, label: 'Models', onClick: (history) => history('/settings/models') },
            { icon: SettingsColorIcon, label: 'Colors', onClick: (history) => history('/settings/colors') },
            { icon: SettingsCategoryIcon, label: 'Categories', onClick: (history) => history('/settings/productcategories') },
            { icon: SettingsGradeIcon, label: 'Grades', onClick: (history) => history('/settings/grades') },
            { icon: SettingsRepairIcon, label: 'Repairs', onClick: (history) => history('/settings/repairs') },
            { icon: SettingsShippingIcon, label: 'Shipping companies', onClick: (history) => history('/settings/shipping-companies') },
            { icon: SettingsSpecificationIcon, label: 'Product Specifications', onClick: (history) => history('/settings/specifications') },
            { icon: SettingsInterestIcon, label: 'Customer Interests', onClick: (history) => history('/settings/interests') },
            { icon: SettingsBankIcon, label: 'Bank', onClick: (history) => history('/settings/banks') },
        ],
    },
    {
        key: 'integrations',
        title: 'Integrations',
        items: [
            { icon: CoolmixIcon, label: 'Coolmix', onClick: (history) => history('/settings/integrations/coolmix') },
            { icon: MixGlobalIcon, label: 'Mix Global', onClick: (history) => history('/settings/role') },
            { icon: GsmfeedIcon, label: 'gsmfeed', onClick: null },
        ],
    },
];

const Main = () => {
    const [setPageTitle] = usePageTitle('Settings');
    useEffect(() => {
        return () => {
            setPageTitle('Settings');
        };
    }, []);
    const history = useNavigate()

    const isMobile = useIsMobile();

    const [accessOpen, setAccessOpen] = useState(false);
    const [openAccordion, setOpenAccordion] = useState(0);
	const appName = config.apps.find((c) => c?.app_urls.includes(window.location.origin))?.app_name;
	
    return (
			<>
				<div className={`row ${isMobile ? 'm-0' : 'settings-container  mt30 mb50'}`}>
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="header-bubble" />
						<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<div
								style={{
									position: 'relative',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginBottom: 8,
									minHeight: 38 // ensures enough height for the button
								}}
							>
								{' '}
								<button
									type="button"
									aria-label="Back"
									onClick={() => history(-1)}
									className="circle-back-btn"
									style={{
										position: 'absolute',
										left: 20,
										top: '50%',
										transform: 'translateY(-50%)'
									}}
								>
									{/* Replace with your fi arrow icon, example below */}
									<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
										<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</button>
								<h5 className="m-0 p-0 pb-2" style={{ fontWeight: '500' }}>
									Settings
								</h5>
							</div>
							<div style={{ height: 10 }}></div>
						</div>
					</div>
					<div className={`${isMobile ? 'mobile-scroll-container' : 'col-12 col-md-12 p-0 p-md-2 inv-preview'}`}>
						{!isMobile ? (
							<>
								<div className="row" style={{ gap: isMobile ? '5px' : '' }}>
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/company-details')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width={isMobile ? '24px' : '30px'}
																height={isMobile ? '24px' : '30px'}
																viewBox="0 0 45.609 45.609"
																className="icon-set"
															>
																<path
																	id="file-circle-info"
																	d="M32.306,19a13.3,13.3,0,1,0,13.3,13.3A13.317,13.317,0,0,0,32.306,19Zm0,22.8a9.5,9.5,0,1,1,9.5-9.5A9.505,9.505,0,0,1,32.306,41.809Zm2.851-14.253a2.851,2.851,0,1,1-2.851-2.851A2.847,2.847,0,0,1,35.157,27.556Zm-.95,6.651v3.8a1.9,1.9,0,1,1-3.8,0v-3.8a1.9,1.9,0,1,1,3.8,0Zm-17.1,5.7a1.906,1.906,0,0,1-1.9,1.9H9.5a9.505,9.505,0,0,1-9.5-9.5V9.5A9.505,9.505,0,0,1,9.5,0H20.448a7.724,7.724,0,0,1,5.378,2.223l6.157,6.157a7.647,7.647,0,0,1,2.2,4.751,1.924,1.924,0,0,1-1.748,2.052h-.152a1.918,1.918,0,0,1-1.9-1.748v-.152H24.724a3.812,3.812,0,0,1-3.8-3.8V3.839c-.152,0-.3-.038-.456-.038H9.5A5.718,5.718,0,0,0,3.8,9.5v22.8a5.718,5.718,0,0,0,5.7,5.7h5.7A1.906,1.906,0,0,1,17.1,39.908Z"
																	fill="currentColor"
																/>
															</svg>
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Company details</div>
														<div className="textGray settings-card-description">Details about your company like name and address. </div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsSubscriptionIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Your Subscription</div>
														<div className="textGray settings-card-description">Your subscription and other terms we made. </div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsPaymentMethodIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Payment Method</div>
														<div className="textGray settings-card-description">Change your payment method. </div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="row">
									<div className="col-12 settings-feature-headers">
										General Settings
										<hr />
									</div>
								</div>

								<div className="row">
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/general-settings')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsEditSettingsIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">General Settings</div>
														<div className="textGray settings-card-description">
															Manage system-wide configurations to optimize functionality that fit your business needs.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsEmailTemplateIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Email Templates</div>
														<div className="textGray settings-card-description">
															Manager email templates and maintain a library to streamline messaging and boost engagement.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsDownloadIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Download Templates</div>
														<div className="textGray settings-card-description">
															Efficiently organize and update your downloadable templates for streamlined access and use.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="row">
									<div className="col-12 settings-feature-headers">
										Access
										<hr />
									</div>
								</div>

								<div className="row">
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/user')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsUsersIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Users</div>
														<div className="textGray settings-card-description">Create or manage the accounts of all your co-workers. </div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/role')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsRolesIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Roles</div>
														<div className="textGray settings-card-description">
															Allows to define and manage your user's access within the system.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsWebsiteIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Client Portal</div>
														<div className="textGray settings-card-description">
															General settings for your client portal where your clients can login.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="row">
									<div className="col-12 settings-feature-headers">
										Categories
										<hr />
									</div>
								</div>

								<div className="row">
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/models')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsModelIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Models</div>
														<div className="textGray settings-card-description">
															Create or manage all the models related to your products quickly, securely, and efficiently.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/colors')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsColorIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Colors</div>
														<div className="textGray settings-card-description">
															Manage and customize color options for seamless branding and product differentiation.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/productcategories')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsCategoryIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Categories</div>
														<div className="textGray settings-card-description">
															Organize and categorize your products for easy navigation and streamlined inventory management.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/grades')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsGradeIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Grades</div>
														<div className="textGray settings-card-description">
															Define and manage product grades to ensure quality control and standardization across your offerings.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/repairs')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsRepairIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Repairs</div>
														<div className="textGray settings-card-description">
															Manage different repair types to streamline service operations and improve workflow efficiency.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/shipping-companies')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsShippingIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Shipping companies</div>
														<div className="textGray settings-card-description">
															Easily manage and update your shipping company information for seamless logistics operations.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/specifications')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsSpecificationIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Product Specifications</div>
														<div className="textGray settings-card-description">
															Streamline and adjust product details to maintain accuracy and meet market demands.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/interests')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsInterestIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Customer Interests</div>
														<div className="textGray settings-card-description">
															Track and update customer interests to align offerings with preferences and market trends.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-4 col-sm-6 col-12">
										<div
											className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
											onClick={() => history('/settings/banks')}
										>
											<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsBankIcon height={isMobile ? '24px' : '30px'} width={isMobile ? '24px' : '30px'} />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Bank</div>
														<div className="textGray settings-card-description">
															Provide and manage your banking information for secure and efficient transactions.{' '}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								{
									appName === 'mixglobal' && (
										<>
											<div className="row">
												<div className="col-12 settings-feature-headers">
													Integrations
													<hr />
												</div>
											</div>

											<div className="row">
												<div className="col-md-4 col-sm-6 col-12">
													<div
														className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
														onClick={() => history('/settings/integrations/coolmix')}
													>
														<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
															<div className="d-flex" style={{ gap: '10px' }}>
																<div className="settings-icon-set color-theme">
																	<div className="settings-icon-bg-container">
																		<CoolmixIcon height={'35px'} width={'35px'} />
																	</div>
																</div>
																<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
																	<div className="settings-card-title ">Coolmix</div>
																	<div className="textGray settings-card-description">Connect and syncronize data from Coolmix. </div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="col-md-4 col-sm-6 col-12">
													<div
														className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}
														onClick={() => history('/settings/role')}
													>
														<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
															<div className="d-flex" style={{ gap: '10px' }}>
																<div className="settings-icon-set color-theme">
																	<div className="settings-icon-bg-container">
																		<MixGlobalIcon height={'35px'} width={'35px'} />
																	</div>
																</div>
																<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
																	<div className="settings-card-title ">Mix Global</div>
																	<div className="textGray settings-card-description">Connect and syncronize data from Mix Global. </div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="col-md-4 col-sm-6 col-12">
													<div className={`${isMobile ? 'settings-button-new' : 'card shadow-sm bg-white mb-4 cursor-pointer card-effect'}`}>
														<div className={`${isMobile ? 'settings-button-new-inner' : 'card-body card-body-settings-container'}`}>
															<div className="d-flex" style={{ gap: '10px' }}>
																<div className="settings-icon-set color-theme">
																	<div className="settings-icon-bg-container">
																		<GsmfeedIcon height={'35px'} width={'35px'} />
																	</div>
																</div>
																<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
																	<div className="settings-card-title ">gsmfeed</div>
																	<div className="textGray settings-card-description">Connect and syncronize data from gsmfeed </div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</>
									)
								}
							</>
						) : (
							<div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '5px' }}>
								{/* First three cards (not accordion) */}
								<div className="row" style={{ gap: '5px' }}>
									<div className="col-12">
										<div className="settings-button-new" onClick={() => history('/settings/company-details')}>
											<div className="settings-button-new-inner">
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="24px"
																height="24px"
																viewBox="0 0 45.609 45.609"
																className="icon-set"
															>
																<path
																	id="file-circle-info"
																	d="M32.306,19a13.3,13.3,0,1,0,13.3,13.3A13.317,13.317,0,0,0,32.306,19Zm0,22.8a9.5,9.5,0,1,1,9.5-9.5A9.505,9.505,0,0,1,32.306,41.809Zm2.851-14.253a2.851,2.851,0,1,1-2.851-2.851A2.847,2.847,0,0,1,35.157,27.556Zm-.95,6.651v3.8a1.9,1.9,0,1,1-3.8,0v-3.8a1.9,1.9,0,1,1,3.8,0Zm-17.1,5.7a1.906,1.906,0,0,1-1.9,1.9H9.5a9.505,9.505,0,0,1-9.5-9.5V9.5A9.505,9.505,0,0,1,9.5,0H20.448a7.724,7.724,0,0,1,5.378,2.223l6.157,6.157a7.647,7.647,0,0,1,2.2,4.751,1.924,1.924,0,0,1-1.748,2.052h-.152a1.918,1.918,0,0,1-1.9-1.748v-.152H24.724a3.812,3.812,0,0,1-3.8-3.8V3.839c-.152,0-.3-.038-.456-.038H9.5A5.718,5.718,0,0,0,3.8,9.5v22.8a5.718,5.718,0,0,0,5.7,5.7h5.7A1.906,1.906,0,0,1,17.1,39.908Z"
																	fill="currentColor"
																/>
															</svg>
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Company details</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-12">
										<div className="settings-button-new">
											<div className="settings-button-new-inner">
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsSubscriptionIcon height="24px" width="24px" />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Your Subscription</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-12">
										<div className="settings-button-new">
											<div className="settings-button-new-inner">
												<div className="d-flex" style={{ gap: '10px' }}>
													<div className="settings-icon-set color-theme">
														<div className="settings-icon-bg-container">
															<SettingsPaymentMethodIcon height="24px" width="24px" />
														</div>
													</div>
													<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
														<div className="settings-card-title ">Payment Method</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								{/* Accordions */}
								{mobileSections.slice(0).map((section, idx) => {
									// Skip the first section (General Settings) for accordion, since you want only the next ones
									return (
										<div
											key={section.key}
											style={{

												overflow: 'hidden',
												background: '#fff',
												borderRadius: 12,
											}}
										>
											<div
												onClick={() => setOpenAccordion(openAccordion === idx ? null : idx)}
												style={{
													cursor: 'pointer',
													padding: '16px 18px',
													background: '#fff',
													border: '1px solid #e0e0e0',
													fontSize: 14,
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'space-between',
													borderTopRightRadius: 12,
													borderTopLeftRadius: 12,
													borderBottomLeftRadius: openAccordion === idx ? 0 : 12,
													borderBottomRightRadius: openAccordion === idx ? 0 : 12
												}}
											>
												<div>{section.title}</div>
												<div
													style={{
														fontSize: 18,
														transition: 'transform 0.2s',
														transform: openAccordion === idx ? 'rotate(90deg)' : 'rotate(0deg)'
													}}
												>
													<FiChevronRight />
												</div>
											</div>
											<AnimatePresence initial={false}>
												{openAccordion === idx && (
													<motion.div
														initial={{ height: 0, opacity: 0 }}
														animate={{ height: 'auto', opacity: 1 }}
														exit={{ height: 0, opacity: 0 }}
														transition={{ duration: 0.25, ease: 'easeInOut' }}
														style={{
															overflow: 'hidden',
															background: '#fff',
															borderRadius: 12,
															border: '1px solid #e0e0e0',
															borderTopLeftRadius: 0,
															borderTopRightRadius: 0,
                                                            borderTop: 'none'
														}}
													>
														<div style={{ padding: ' 0' }}>
															{section.items.map((item, i) => (
																<div
																	key={item.label}
																	onClick={() => item.onClick && item.onClick(history)}
																	className="settings-accordion-item"
																>
																	<div className="settings-icon-set color-theme">
																		<div className="settings-icon-bg-container">
																			<item.icon height="24px" width="24px" />
																		</div>
																	</div>
																	<div style={{ flex: 1 }}>
																		<div className="settings-card-title" style={{  fontSize: 14 }}>
																			{item.label}
																		</div>
																	</div>
																</div>
															))}
														</div>
													</motion.div>
												)}
											</AnimatePresence>
										</div>
									);
								})}
							</div>
						)}
					</div>
				</div>
			</>
		);
}

export default Main
